'use strict';

exports.__esModule = true;
exports.selectMeta = exports.selectData = exports.createAction = exports.toReset = exports.toSuccess = exports.toRequest = exports.toError = exports.toLoad = exports.SagaProvider = exports.asyncConnect = exports.withSagas = exports.withAsyncHandlers = exports.withAsyncActions = exports.defaultKey = exports.noParamsKey = exports.noParamsReducer = exports.getAsyncReducers = exports.getAsyncSagas = exports.createAsyncAction = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _withAsyncActions = require('./withAsyncActions');

Object.defineProperty(exports, 'withAsyncActions', {
  enumerable: true,
  get: function get() {
    return _withAsyncActions.withAsyncActions;
  }
});

var _withAsyncHandlers = require('./withAsyncHandlers');

Object.defineProperty(exports, 'withAsyncHandlers', {
  enumerable: true,
  get: function get() {
    return _withAsyncHandlers.withAsyncHandlers;
  }
});

var _withSagas = require('./withSagas');

Object.defineProperty(exports, 'withSagas', {
  enumerable: true,
  get: function get() {
    return _withSagas.withSagas;
  }
});

var _asyncConnect = require('./asyncConnect');

Object.defineProperty(exports, 'asyncConnect', {
  enumerable: true,
  get: function get() {
    return _asyncConnect.asyncConnect;
  }
});

var _SagaProvider = require('./SagaProvider');

Object.defineProperty(exports, 'SagaProvider', {
  enumerable: true,
  get: function get() {
    return _SagaProvider.SagaProvider;
  }
});

var _actionHelpers = require('./actionHelpers');

Object.defineProperty(exports, 'toLoad', {
  enumerable: true,
  get: function get() {
    return _actionHelpers.toLoad;
  }
});
Object.defineProperty(exports, 'toError', {
  enumerable: true,
  get: function get() {
    return _actionHelpers.toError;
  }
});
Object.defineProperty(exports, 'toRequest', {
  enumerable: true,
  get: function get() {
    return _actionHelpers.toRequest;
  }
});
Object.defineProperty(exports, 'toSuccess', {
  enumerable: true,
  get: function get() {
    return _actionHelpers.toSuccess;
  }
});
Object.defineProperty(exports, 'toReset', {
  enumerable: true,
  get: function get() {
    return _actionHelpers.toReset;
  }
});
Object.defineProperty(exports, 'createAction', {
  enumerable: true,
  get: function get() {
    return _actionHelpers.createAction;
  }
});

var _asyncHelpers = require('./asyncHelpers');

Object.defineProperty(exports, 'selectData', {
  enumerable: true,
  get: function get() {
    return _asyncHelpers.selectData;
  }
});
Object.defineProperty(exports, 'selectMeta', {
  enumerable: true,
  get: function get() {
    return _asyncHelpers.selectMeta;
  }
});

var _saga = require('./utils/saga');

Object.keys(_saga).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _saga[key];
    }
  });
});

var _doAction = require('./utils/doAction');

Object.keys(_doAction).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _doAction[key];
    }
  });
});

var _cache = require('./utils/cache');

Object.keys(_cache).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _cache[key];
    }
  });
});

var _redux = require('redux');

var _ramda = require('ramda');

var _ramdaAdditions = require('./utils/ramdaAdditions');

var _noParamsReducer = require('./noParamsReducer');

var _noParamsReducer2 = _interopRequireDefault(_noParamsReducer);

var _createHttpReducer = require('./createHttpReducer');

var _createHttpReducer2 = _interopRequireDefault(_createHttpReducer);

var _createMetaReducer = require('./createMetaReducer');

var _createMetaReducer2 = _interopRequireDefault(_createMetaReducer);

var _createSaga = require('./createSaga');

var _createSaga2 = _interopRequireDefault(_createSaga);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var sagas = [];
var dataReducers = {};
var metaReducers = {};
var getDefaultConfig = (0, _ramda.pickAll)(['params', 'defaultPayload', 'options', 'shouldUpdate', 'successHandler', 'errorHandler', 'pendingHandler', 'saga']);

var createConfigurableAction = function createConfigurableAction(action) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var newAction = (0, _actionHelpers.createAction)(action.type);

  var newConfig = _extends({}, getDefaultConfig(action), config);

  function withConfig(name) {
    return function (value) {
      return createConfigurableAction(newAction, _defineProperty({}, name, value));
    };
  }

  (0, _ramda.mapObjIndexed)(function (value, key) {
    newAction[key] = value;
    var withKey = 'with' + (0, _ramdaAdditions.capitalize)(key);
    newAction[withKey] = withConfig(key);
  }, newConfig); // @deprecated

  newAction.withPayload = newAction.withDefaultPayload;

  newAction.selectData = function (state, props) {
    return (0, _asyncHelpers.getActionData)(newAction, state, props);
  };

  newAction.selectMeta = function (state, props) {
    return (0, _asyncHelpers.getActionMeta)(newAction, state, props);
  };

  return newAction;
};

function configAsyncAction(actionName, handler, initialState, taker, customReducer, customSagaGenerator) {
  var action = (0, _actionHelpers.createAction)(actionName);
  var dataReducer = (0, _createHttpReducer2.default)(actionName, initialState, customReducer);
  var metaReducer = (0, _createMetaReducer2.default)(actionName);
  var saga = (0, _createSaga2.default)(customSagaGenerator, taker)(action);
  (0, _doAction.setActionHandler)(actionName, handler);
  dataReducers[actionName] = dataReducer;
  metaReducers[actionName] = metaReducer;
  sagas.push(saga);
  return createConfigurableAction(action);
}

function getAsyncSagas() {
  return sagas;
}

function getAsyncReducers() {
  return !(0, _ramda.isEmpty)(dataReducers) && {
    asyncClient: (0, _redux.combineReducers)({
      data: (0, _redux.combineReducers)(dataReducers),
      meta: (0, _redux.combineReducers)(metaReducers)
    })
  };
}

function createAsyncAction() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var action = (0, _ramda.head)(args);

  if ((0, _ramda.is)(String, action)) {
    return configAsyncAction.apply(undefined, args);
  } else {
    return configAsyncAction(action.actionName, action.handler, action.initialState, action.taker, action.customReducer, action.customSagaGenerator);
  }
}

exports.createAsyncAction = createAsyncAction;
exports.getAsyncSagas = getAsyncSagas;
exports.getAsyncReducers = getAsyncReducers;
exports.noParamsReducer = _noParamsReducer2.default;
exports.noParamsKey = _asyncHelpers.noParamsKey;
exports.defaultKey = _asyncHelpers.defaultKey;